export default __webpack_public_path__ + "static/media/tech.e05fa793.PNG";